import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import GenericForm from "../genericForm";

function AddWbs() {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [data] = useState(null);
	const [error] = useState("");

	const inputFields = [
		{
			type: "text",
			name: "code",
			label: "Codice WBS",
		},
		{
			type: "text",
			name: "name",
			label: "Nome",
		},
	];

	const requiredFields = [
		{ name: "name", nameDiplayed: "nome" },
		{ name: "code", nameDiplayed: "codice WBS" },
	];

	return (
		<DashboardLayout>
			{authContext.hasAuth("ADD_JOBS") ? (
				<>
					<DashboardNavbar />
					<MDBox pt={6} pb={3}>
						<Button variant="contained" color="primary" onClick={() => navigate("/wbs-managment")} sx={{ mt: 2, alignSelf: "center", minWidth: "100px", color: "#ffffff", marginBottom: "30px" }}>
							Torna alla tabella
						</Button>
						{error !== "" ? <Alert severity="error">{error}</Alert> : <GenericForm authModelName={"JOBS"} inputFields={inputFields} requiredFields={requiredFields} url="/wbs-management/" old_data={data} useAPI={true} redirectOnSuccess="/wbs-managment/edit" />}
					</MDBox>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

export default AddWbs;
